import { useState } from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { toast } from "sonner";

export const WhatsAppSharePanel = ({ order }) => {
  const [waNumber, setWaNumber] = useState("");

  const shareOnWhatsApp = () => {
    let digits = waNumber.replace(/\D/g, "");
    if (digits.length === 10) digits = "91" + digits;
    if (digits.length < 11) {
      toast.error("Enter a valid mobile number (10 digits, or with country code)");
      return;
    }
    const d = order.dispatch || {};
    const lines = [
      `*DCN Order Update — ${order.order_number}*`,
      `Customer: ${order.customer_name} (${order.location})`,
      `Status: ${order.status_label}`,
      `Items: ${order.items.map((i) => `${i.product_name} x${i.quantity}`).join(", ")}`,
    ];
    if (order.dispatched_quantity) lines.push(`Dispatched Qty: ${order.dispatched_quantity}`);
    if (d.dispatch_date) lines.push(`Dispatch Date: ${d.dispatch_date}`);
    if (d.transporter_name) lines.push(`Transporter: ${d.transporter_name}`);
    if (d.vehicle_number) lines.push(`Vehicle No: ${d.vehicle_number}`);
    if (d.lr_number) lines.push(`LR No: ${d.lr_number}`);
    if (d.driver_mobile) lines.push(`Driver Mobile: ${d.driver_mobile}`);
    lines.push("— DCN Food and Beverages");
    window.open(`https://wa.me/${digits}?text=${encodeURIComponent(lines.join("\n"))}`, "_blank");
  };

  return (
    <div className="rounded-md border border-emerald-300 bg-emerald-50/60 p-5" data-testid="whatsapp-share-panel">
      <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
        <WhatsappLogo size={18} weight="duotone" className="text-emerald-600" /> Share on WhatsApp
      </h2>
      <p className="mt-1 text-xs text-slate-500">
        Send the current status and dispatch details to any mobile number.
      </p>
      <input data-testid="whatsapp-number-input" type="tel" value={waNumber}
        onChange={(e) => setWaNumber(e.target.value)} placeholder="Mobile number e.g. 9876543210"
        className="mt-3 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-emerald-600" />
      <button data-testid="whatsapp-send-button" onClick={shareOnWhatsApp}
        className="mt-3 flex w-full items-center justify-center gap-2 rounded-md bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-emerald-700">
        <WhatsappLogo size={16} weight="bold" /> Send on WhatsApp
      </button>
    </div>
  );
};
